import { cx } from './cx';
import './components.css';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  /** A count or figure shown after the label. */
  badge?: string | number;
  disabled?: boolean;
}

export interface SegmentedProps<T extends string> {
  options: Array<SegmentedOption<T>>;
  value: T;
  onChange: (value: T) => void;
  /** Announced group name — required, this is a real control. */
  ariaLabel: string;
  /** 44px targets for a phone. */
  large?: boolean;
  className?: string;
}

/** The app's only tab/filter control. Scrolls horizontally rather than wrapping. */
export function Segmented<T extends string>({
  options, value, onChange, ariaLabel, large, className,
}: SegmentedProps<T>) {
  return (
    <div className={cx('k-seg', large && 'k-seg--lg', className)} role="tablist" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          disabled={o.disabled}
          className="k-seg__btn"
          onClick={() => onChange(o.value)}
        >
          {o.label}
          {o.badge != null && <span className="k-seg__badge num">{o.badge}</span>}
        </button>
      ))}
    </div>
  );
}
